module.exports = __webpack_public_path__ + "img/国网.64745be1.png";